import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ApiPartnerService } from "@app/api/api-partner.service";
import swal from "sweetalert/dist/sweetalert.min.js";

@Component({
  selector: "app-message-template",
  templateUrl: "./message-template.component.html",
  styleUrls: ["./message-template.component.css"],
})
export class MessageTemplateComponent implements OnInit {

  @ViewChild("closeBtn", { static: false }) closeBtn: ElementRef;

  listTemplates: any[] = [];
  table_load = true;

  paging: any = {};
  page_self: any = [];
  page_next: any = [];
  page_prev: any = [];
  meta: any = [];

  last_index: number;
  first_index: number;
  total_count: number;

  querySearch = false;
  currentParams = {};
  queryParams = "";
  searchQueryParams = "";

  limit = 10;
  msearch: string;
  textSearch = new FormControl("");

  alert_act: "add" | "view";
  message: string;
  itemset: any = {};

  formSet = this.fb.group({
    title: ["", Validators.required],
    sub_title: [""],
    type: ["general"],
    message: ["", Validators.required],
    flag_active: [1],
  });

  constructor(
    public partnerService: ApiPartnerService,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.loadStart();
  }

  /* ===================== UTIL ===================== */

  queryStr(options: any) {
    let params = new URLSearchParams();
    for (let key in options) {
      params.set(key, options[key]);
    }
    return params.toString();
  }

  private closeModal(): void {
    this.closeBtn.nativeElement.click();
  }

  alertsx(message: string) {
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
    });
    setTimeout(() => {
      this.loadStart();
    }, 800);
  }

  alertfx(message: string) {
    swal({
      title: "Gagal!",
      text: message,
      icon: "error",
    });
  }

  trackByFn(index: number): number {
    return index;
  }

  /* ===================== LOAD & SEARCH ===================== */

  loadStart() {
    this.route.queryParams.subscribe((params) => {
      this.currentParams = params;
      this.queryParams = "?" + this.queryStr(params);
      this.loadTemplates(this.queryParams);
    });
    this.msearch = undefined;
  }

  refreshPage() {
    this.ngOnInit();
  }

  search() {
    this.querySearch = true;

    if (this.msearch === undefined) {
      this.msearch = "";
    }

    this.searchQueryParams =
      "?page=" +
      this.page_self["page"] +
      "&search=" +
      this.msearch +
      "&limit=" +
      this.limit;

    this.loadTemplates(this.searchQueryParams);
  }

  loadTemplates(params: any) {
    this.table_load = true;

    this.partnerService.GetMessageTemplates(params).subscribe((output: any) => {
      this.listTemplates = output.data;
      this.table_load = false;

      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;

      this.total_count = this.meta.totalCount;
      let self = this.page_self.page;

      if (self * this.meta.perPage < this.meta.totalCount) {
        this.last_index = self * this.meta.perPage;
      } else {
        this.last_index = this.meta.totalCount;
      }
      this.first_index = (self - 1) * this.meta.perPage + 1;
    });
  }

  /* ===================== ACTION ===================== */

  onActionClick(act: "add" | "view", item: any = null) {
    this.alert_act = act;

    if (act === "add") {
      this.clearForm();
    }

    if (act === "view" && item) {
      this.itemset = item;
      this.clearForm();
      this.loadTemplateDetail(item.id);
    }
  }

  clearForm() {
    this.formSet.reset();
    this.formSet.get("flag_active").setValue("1");
  }

  loadTemplateDetail(id: number) {
    this.partnerService.GetMessageTemplateDetail(id).subscribe((output: any) => {
      const data = output.data;
      this.formSet.patchValue({
        title: data.title,
        sub_title: data.sub_title,
        type: data.type,
        message: data.message,
        flag_active: data.flag_active,
      });
    });
  }

  /* ===================== SUBMIT ===================== */

  submitAdd() {
    this.partnerService
      .CreateMessageTemplate(this.formSet.value)
      .subscribe((output: any) => {
        if (output.status) {
          this.message = output.message;
          this.alertsx(this.message);
        } else {
          this.alertfx(output.message);
        }
      });
  }

  submitSet() {
    const id = this.itemset.id;

    const payload = {
      ...this.formSet.value,
      flag_active: 1
    };

    this.partnerService
      .UpdateMessageTemplate(id, payload)
      .subscribe((output: any) => {
        if (output.status) {
          this.message = output.message;
          this.alertsx(this.message);
        } else {
          this.alertfx(output.message);
        }
      });
  }

  submitDelete() {
    const id = this.itemset.id;

    swal({
      title: "Are you sure?",
      text: `"${this.itemset.title}" will be deleted`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.partnerService.DeleteMessageTemplate(id).subscribe((output: any) => {
          if (output.status) {
            this.message = output.message;
            this.alertsx(this.message);
            this.closeModal();
          } else {
            this.alertfx(output.message);
          }
        });
      }
    });
  }
}
